export const internalRoutes = {
  HOME: "/",
  SOLUTIONS: "/solutions/",
  ROADMAP: "/r+d-roadmap/",
  TECHNOLOGY: "/technology/",
  DECARBONIZATION: "/decarbonization/",
  RESOURCES: "/resources/",
  ADDITIONAL_RESOURCES: "/resources/#additional-resources",
  SCIENTIFIC_PAPERS: "/resources/#scientific-papers",
  ABOUT: "/about/",
  NEWS: "/news/",
  CAREERS: "/careers/",
  CONTACT: "/contact/",
  PRIVACY_POLICY: "/privacy-policy/",
  TERMS_OF_SERVICE: "/terms-of-service/",
  COC_ACP: "/code-of-conduct-and-anti-corruption-policy/",
}

export const externalRoutes = {
  TWITTER: "https://mobile.twitter.com/SyzygyPlasmonic",
  LINKEDIN: "https://www.linkedin.com/company/syzygy-plasmonics/",
  FACEBOOK: "https://www.facebook.com/SyzygyPlasmonics/",
}
